import { forwardRef } from "react";

const QuotationPreview = forwardRef(({ formData, total }, ref) => {
  const fmt = (v) => new Intl.NumberFormat("en-IN").format(v || 0);
  const fmtDate = (d) => {
    if (!d) return "";
    try { return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" }); }
    catch { return d; }
  };

  const rows = [
    { label: "Ex-showroom", value: formData.exShowroomPrice },
    { label: "RTO", value: formData.rtoCharges },
    { label: "Insurance", value: formData.insuranceCharges },
    { label: "HPA", value: formData.hpaCharges },
    { label: "Handling/TP", value: formData.handlingCharges },
    { label: "Accessories", value: formData.accessoriesCharges },
    { label: "Other", value: formData.otherCharges },
  ];

  return (
    <div
      ref={ref}
      className="print-document bg-white text-black mx-auto"
      style={{
        fontFamily: "Arial, sans-serif",
        fontSize: "12px",
        width: "100%",
        maxWidth: "210mm",
        padding: "14mm",
        boxSizing: "border-box",
        minHeight: "277mm",
        color: "#000",
        background: "#fff",
      }}
    >
      {/* ── Header ──────────────────────────────────────────────── */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "2px solid #000", paddingBottom: "10px", marginBottom: "10px" }}>
        <img
          src="https://customer-assets.emergentagent.com/job_384f5a02-e73c-441b-8711-7b4aa811af91/artifacts/1llnvk1o_be6ba909-56b0-4515-9de1-7b59366d1e68_Untitled.avif"
          alt="Logo" style={{ height: "105px", objectFit: "contain" }}
          onError={(e) => { e.target.style.display = "none"; }}
        />
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: "27px", fontWeight: "bold" }}>SHREE MOBILITY TRADE</div>
          <div style={{ fontSize: "11px", color: "#555" }}>(Authorised Dealer of Kinetic Green)</div>
          <div style={{ fontSize: "11px" }}>NH 14, Brahmanigram more, Rampurhat</div>
          <div style={{ fontSize: "11px", fontWeight: "600" }}>Mob: 9749430705 / 7063511705</div>
          <div style={{ fontSize: "11px", fontWeight: "600" }}>GSTIN: 19AFQFS8958E1Z2</div>
        </div>
      </div>

      {/* ── Doc Title ────────────────────────────────────────────── */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
        <div style={{ fontSize: "11px", lineHeight: "1.7" }}>
          <div><b>No.:</b> {formData.quotationNumber}</div>
          <div><b>Date:</b> {fmtDate(formData.quotationDate)}</div>
          {formData.validUntil && <div><b>Valid Until:</b> {fmtDate(formData.validUntil)}</div>}
        </div>
        <div style={{ border: "2px solid #000", padding: "5px 18px", fontWeight: "bold", fontSize: "16px" }}>Quotation</div>
      </div>

      {/* ── Customer ─────────────────────────────────────────────── */}
      <div style={{ marginBottom: "10px", fontSize: "11px", lineHeight: "1.9" }}>
        <div><b>To,</b></div>
        <div>
          <b>Mr./Mrs./Ku. — </b>
          <span style={{ borderBottom: "1px solid #000", display: "inline-block", minWidth: "280px" }}>{formData.customerName || ""}</span>
        </div>
        <div>
          <b>Address — </b>
          <span style={{ borderBottom: "1px solid #000", display: "inline-block", minWidth: "280px" }}>{formData.customerAddress || ""}</span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>
            <b>HYP — </b>
            <span style={{ borderBottom: "1px solid #000", display: "inline-block", minWidth: "180px" }}>{formData.hypothecation || ""}</span>
          </span>
          <span>
            <b>Mob — </b>
            <span style={{ borderBottom: "1px solid #000", display: "inline-block", minWidth: "120px" }}>{formData.customerPhone || ""}</span>
          </span>
        </div>
      </div>

      {/* ── Greeting ─────────────────────────────────────────────── */}
      <div style={{ marginBottom: "10px", fontSize: "11px" }}>
        <div style={{ fontWeight: "600" }}>Dear Sir/Madam,</div>
        <div style={{ marginTop: "3px" }}>While thanking for your enquiry. We are pleased to quote our lowest as under:</div>
      </div>

      {/* ── Price Table ──────────────────────────────────────────── */}
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "12px", fontSize: "11px" }}>
        <thead>
          <tr style={{ background: "#f3f3f3" }}>
            <th style={{ border: "1px solid #000", padding: "6px 8px", textAlign: "left", fontWeight: "bold" }}>MODEL</th>
            <th style={{ border: "1px solid #000", padding: "6px 8px", textAlign: "right", fontWeight: "bold", width: "200px" }}>AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ border: "1px solid #000", padding: "8px" }}>
              <div style={{ fontWeight: "600" }}>Cost of New Three Wheeler</div>
              <div style={{ marginTop: "3px" }}>Model: <b>{formData.vehicleModel || "_______________"}</b></div>
              {formData.vehicleColor && <div>Color: {formData.vehicleColor}</div>}
            </td>
            <td style={{ border: "1px solid #000", padding: "8px", verticalAlign: "top" }}>
              <table style={{ width: "100%", borderSpacing: 0 }}>
                <tbody>
                  {rows.map(({ label, value }) => (
                    <tr key={label}>
                      <td style={{ paddingBottom: "3px" }}>{label} —</td>
                      <td style={{ paddingBottom: "3px", textAlign: "right", fontWeight: "600", paddingLeft: "8px" }}>
                        {value ? `₹${fmt(value)}` : "___________"}
                      </td>
                    </tr>
                  ))}
                  {parseFloat(formData.discount) > 0 && (
                    <tr>
                      <td style={{ paddingBottom: "3px", color: "#c05000" }}>Discount —</td>
                      <td style={{ paddingBottom: "3px", textAlign: "right", fontWeight: "600", paddingLeft: "8px", color: "#c05000" }}>
                        – ₹{fmt(formData.discount)}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td colSpan={2} style={{ borderTop: "2px solid #000", paddingTop: "5px", marginTop: "3px" }}></td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", fontSize: "13px" }}>Grand Total —</td>
                    <td style={{ textAlign: "right", fontWeight: "bold", fontSize: "13px", paddingLeft: "8px" }}>₹{fmt(total)}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>

      {/* ── Bank ─────────────────────────────────────────────────── */}
      <div style={{ background: "#f9f9f9", border: "1px solid #000", padding: "8px 10px", marginBottom: "12px", fontSize: "11px" }}>
        <div style={{ fontWeight: "bold", marginBottom: "4px", textTransform: "uppercase", fontSize: "10px" }}>Our Bank Details for NEFT/RTGS</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2px 16px" }}>
          <div><b>A/C Name:</b> SHREE MOBILITY TRADE</div>
          <div><b>A/C Type:</b> Current</div>
          <div><b>A/C No.:</b> 1888102000011024</div>
          <div><b>Bank Name:</b> IDBI BANK</div>
          <div><b>Branch:</b> Rampurhat</div>
          <div><b>IFSC Code:</b> IBKL0001888</div>
        </div>
      </div>

      {/* ── Terms ────────────────────────────────────────────────── */}
      <div style={{ marginBottom: "20px", fontSize: "10.5px" }}>
        <b>TERMS & CONDITIONS OF SALE:</b>
        <ul style={{ margin: "4px 0 0 16px", padding: 0, lineHeight: "1.8" }}>
          <li>Warranty as per manufacturer's policy on vehicle and battery.</li>
          <li>Vehicle remains showroom property until full payment is made.</li>
          <li>All disputes under Rampurhat legal jurisdiction.</li>
          <li>Delivery date will depend on stock and conditions.</li>
          {formData.notes && <li>{formData.notes}</li>}
        </ul>
      </div>

      {/* ── Signatures ───────────────────────────────────────────── */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", paddingTop: "16px" }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ borderTop: "1px solid #000", width: "150px", paddingTop: "4px", fontSize: "11px" }}>Customer's Signature</div>
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "11px", fontWeight: "600", marginBottom: "24px" }}>For, SHREE MOBILITY TRADE</div>
          <div style={{ borderTop: "1px solid #000", width: "150px", paddingTop: "4px", fontSize: "11px" }}>Authorised Signatory</div>
        </div>
      </div>
    </div>
  );
});

QuotationPreview.displayName = "QuotationPreview";
export default QuotationPreview;
